export function getFileType (link) {
  let type = link.match(/([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gmi)[0]
  let possibleTypes = {
    video: ['mp4', 'webm'],
    image: ['png', 'jpeg', 'jpg'],
    pdf: ['pdf'],
    document: ['doc', 'docx']
  }
  for (let fileType in possibleTypes) {
    if (possibleTypes[fileType].includes(type)) return fileType
  }
}
/*
 
  Ця функція призначена для отримання правильної форми іменника в залежності від числа.

  number: Це число, для якого потрібно отримати форму іменника.
          Функція визначає, яку форму використовувати на основі цього числа.

  singular: Це форма іменника для випадку, коли число дорівнює 1.
            Наприклад, "сторінка" або "елемент".

  plural1: Це форма іменника для випадку, коли число дорівнює 2, 3 або 4.
            Наприклад, "сторінки" або "елементи".

  plural2: Це форма іменника для випадку, коли число не підпадає під жодну з попередніх категорій.
            Наприклад, "сторінок" або "елементів".
  
  Функція використовує останню цифру числа, а також останні дві цифри для визначення правильної форми іменника
  з урахуванням англійського винятку для чисел від 11 до 19.
*/
export function getNounForm(number, singular, plural1, plural2) {
    // Визначення останньої цифри числа (для англійської - також перевірка на 11-19)
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return plural2;
    }

    if (lastDigit === 1) {
        return singular;
    } else if (lastDigit >= 2 && lastDigit <= 4) {
        return plural1;
    } else {
        return plural2;
    }
}

// Ця функція призначена для капіталізації першої літери слова.
export function capitalizeFirstLetter(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

export function generateFilterParams(filter) {
  if (filter && Object.keys(filter).length) {
    const params = new URLSearchParams()
    for (let field in filter) {
      filter[field] && params.append(field, filter[field])
    }
    return '?' + params
  }
  return ''
}

export function scrollToError (gap = 30) {
  const errorField = document.getElementsByClassName('error--text')[0]
  if (errorField) {
    const headerHeight = 48 
    const elementPosition = errorField.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerHeight - gap 
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }
}